<template>
  <div class="content">
      <div class="row">
        <div class="col-sm-12 col-md-6"></div>
        <div class="col-sm-12 col-md-6">
          <div class="datatable_filter float-right">
            <div class="row">
              <div class="col">
                <div class="form-check" v-if="permissions.indexOf('archive-users') != -1">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="showNextContactToday"
                    v-model="filter.archive"
                    @change="fetchUsers"
                    true-value="1"
                    false-value="0"
                  >
                  <label class="form-check-label" for="showNextContactToday">
                    {{ $t('users.show_deleted_users') }}
                  </label>
                </div>
              </div>
              <div class="col">
                <label>
                  <select v-model="tableData.length" @change="fetchUsers()" class="form-control form-control-sm">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">
            Сотрудники {{pagination.total ? '(' + pagination.total + ')': '' }}
          </h3>
          <div class="block-options">
            <b-btn v-b-modal.addUser size="sm" variant="primary"><i class="fa fa-user-plus" aria-hidden="true"></i> {{ $t('users.add') }}</b-btn>
          </div>
        </div>
        <div class="table-responsive">
          <datatable
            :columns="columns"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :loading="loadUsers"
            @sort="sortBy"
          >
              <tbody>
                <tr v-for="(user, index) in users" :key="user.id">
                  <td>{{index+1}}</td>
                  <td>
                    <div class="btn-group">
                      <b-btn
                        v-b-modal.add-task
                        size="sm"
                        @click.prevent="setUserId(user.id)"
                        variant="info"
                        v-if="!user.deleted_at && permissions.indexOf('create-debt-tasks') != -1"
                        title="Добавить отработку должников по статусам"
                      >
                        <i class="fa fa-clock-o"></i>
                      </b-btn>
                      <router-link
                        :to="`/admin/users/${user.id}/view`"
                        active-class="active"
                        class="btn btn-primary btn-sm"
                        v-if="!user.deleted_at && permissions.indexOf('read-users') != -1"
                        title="Просмотр"
                      >
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </router-link>
                      <button
                        @click.prevent="handleDelete(user.id)"
                        class="btn btn-danger btn-sm "
                        v-if="!user.deleted_at && permissions.indexOf('delete-users') != -1"
                        title="Удалить"
                      >
                        <i class="fa fa-times-circle"></i>
                      </button>
                      <!--Deleted-->
                      <button
                        @click.prevent="restoreUser(user.id)"
                        class="btn btn-success btn-sm "
                        v-if="user.deleted_at"
                        :disabled="isProcessing"
                        title="Восстановить"
                      >
                        {{ $t('buttons.restore') }}
                      </button>
                      <button
                        @click.prevent="handleForceDelete(user.id)"
                        class="btn btn-danger btn-sm "
                        v-if="user.deleted_at"
                        :disabled="isProcessing"
                        title="Окончательно удалить"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </div>
                  </td>
                  <td>{{user.lastname}} {{user.firstname}} {{user.middlename}}</td>
                  <td>{{user.login}}</td>
                  <td>{{user.phone}}</td>
                  <td>
                    <span v-for="team in user.teams" :key="team.id">
                      {{team.display_name}}<br>
                    </span>
                  </td>
                  <td>
                    <span v-for="role in user.getroles" :key="role.id">
                      {{role.display_name}}<br>
                    </span>
                  </td>
                  <td>{{user.debts_count ? (user.debts_count[0] ? user.debts_count[0].aggregate: '0' ): '0' }}</td>
                  <td>
                    <span
                      @dblclick="editRedemptionPlan(user.id, user.redemption_plans)"
                      v-show="user.id !== redemption_plan.user_id"
                    >
                      {{user.redemption_plans ? (user.redemption_plans[0] ? user.redemption_plans[0].amount: 0) : 0 | formatNumber }} {{ $t('app.kzt') }}
                    </span>
                    <div v-show="user.id == redemption_plan.user_id">
                      <input
                        type="number"
                        class="form-control"
                        v-model="redemption_plan.amount"
                        min="0"
                        @keyup.enter="submitRedemptionPlan()"
                        @keyup.esc="cancelRedemptionPlan()"
                        @blur="cancelRedemptionPlan()"
                        :class="{'is-invalid': errors.amount }"
                      >
                      <span v-if="errors.amount" class="invalid-feedback">
                          <strong>{{ errors.amount ? errors.amount[0] : '' }}</strong>
                      </span>
                    </div>
                    <i v-if="user.id == processingID" class="fa fa-spinner fa-pulse"></i>
                  </td>
                </tr>
                <tr v-if="users.length == 0 && !loadUsers">
                  <td colspan="8" class="text-center">{{ $t('app.empty') }}</td>
                </tr>
              </tbody>
          </datatable>
        </div>
      </div>
      <pagination :pagination="pagination" :offset="4" @paginate="fetchUsers()"/>
      <users-create @fetchUsers="fetchUsers" />
      <add-debt-task :user-id="user_id" @fetchUsers="fetchUsers" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    UsersCreate: () => import('@/components/admin/users/create.vue'),
    AddDebtTask: () => import('@/components/admin/users/addDebtTaskModal.vue'),
  },
  data() {
    return {
      users: [],
      user_id: '',
      columns: [
        { label: '#', name: 'id', disableOrder: true },
        { label: '', name: 'action', disableOrder: true },
        { label: this.$t('users.fullname'), name: 'fullname' },
        { label: this.$t('users.login'), name: 'login' },
        { label: this.$t('users.phone'), name: 'phone' },
        { label: this.$t('users.team'), name: 'teams' },
        { label: this.$t('users.role'), name: 'roles', width: '120px' },
        { label: this.$t('users.debts_count'), name: 'debts', width: '120px' },
        { label: this.$t('users.redemption_plan'), name: 'redemption_plans', width: '120px' },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc',
      },
      pagination: {
        current_page: 1,
      },
      filter: {
        archive: 0,
      },
      errors: {},
      loadUsers: false,
      isProcessing: false,
      redemption_plan: {
        user_id: null,
        amount: 0,
      },
      processingID: null,
    };
  },
  computed: {
    ...mapGetters([
      'permissions',
    ]),
  },
  created() {
    this.fetchUsers();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  methods: {
    fetchUsers() {
      this.loadUsers = true;
      this.tableData.draw += 1;
      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/admin/users?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.users = res.data.users.data;
            this.pagination = this.laraPaginate(res.data.users);
          } else {
            console.log('failed');
          }
          this.loadUsers = false;
        });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchUsers();
    },

    editRedemptionPlan(userId, redemptionPlans) {
      this.redemption_plan.user_id = userId;
      const redPlanAmount = redemptionPlans[0] ? redemptionPlans[0].amount : 0;
      this.redemption_plan.amount = redemptionPlans ? redPlanAmount : 0;
    },

    cancelRedemptionPlan() {
      this.redemption_plan.user_id = null;
      this.redemption_plan.amount = 0;
    },

    submitRedemptionPlan() {
      if (this.redemption_plan.amount > 0) {
        this.processingID = this.redemption_plan.user_id;
        window.axios.post(`/admin/users/${this.redemption_plan.user_id}/set/redemptionplan`, this.redemption_plan)
          .then(() => {
            this.redemption_plan.user_id = null;
            this.redemption_plan.amount = 0;
            this.fetchUsers();
          })
          .catch((err) => {
            this.errors = this.laravelValidation(err);
          })
          .finally(() => {
            this.processingID = null;
          });
      } else {
        this.cancelRedemptionPlan();
      }
    },

    setUserId(id) {
      this.user_id = id;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteUser(id);
        }
      });
    },

    handleForceDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_forcedelete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.forceDeleteUser(id);
        }
      });
    },

    deleteUser(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/users/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchUsers();
          }
          this.isProcessing = false;
        });
    },

    restoreUser(id) {
      window.axios.put(`/admin/users/${id}/restore`)
        .then((res) => {
          if (res.status === 202) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchUsers();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    forceDeleteUser(id) {
      window.axios.delete(`/admin/users/${id}/forcedelete`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchUsers();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
